import { render, staticRenderFns } from "./elasticHeader.vue?vue&type=template&id=1be6ff54"
import script from "./elasticHeader.vue?vue&type=script&lang=js"
export * from "./elasticHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports